import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Divider } from '~/components/ui/Divider';
import { ScrollContainer } from '~/components/ui/ScrollContainer';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction } from '~/rage';
import { InputAction } from '~/shared';
import {
	setModalSkillsVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import {
	StyledCircle,
	StyledContainer,
	StyledHeadContainer,
	StyledLevelHead,
	StyledLevelItem,
	StyledLevelsContainer,
	StyledModalWrapper,
} from './ModalSkills.styled';

const ModalSkills = () => {
	const dispatch = useLayoutDispatch();
	const activeModalSkill = useLayoutSelector(
		(state) => state.mainMenu.activeModalSkill,
	);

	const skillData = rage.skills.getSkillLevel(activeModalSkill).getValue();

	useInputAction(InputAction.CommonMenuClose, () =>
		dispatch(setModalSkillsVisible(false)),
	);

	return (
		<StyledModalWrapper>
			<StyledContainer>
				<StyledHeadContainer>
					<Text>Навык рыболовства</Text>
					<CloseButton
						height={ButtonHeight.Height20}
						color={ButtonColors.Default}
						borderRadius={ButtonBorderRadius.Radius5}
						iconSize={10}
						onClick={() => dispatch(setModalSkillsVisible(false))}
					/>
				</StyledHeadContainer>
				<Divider
					$direction={'H'}
					style={{ marginTop: 30, marginBottom: 30, opacity: 0.1 }}
				/>
				<Text style={{ fontSize: 14, color: 'rgba(255,255,255,0.5)' }}>
					Важно!
					<br />
					<br />
					Чтобы прокачивать уровень рыболовства, вам нужно использовать
					инструменты, которые открываются у вас на новом уровне. Если вы
					продолжите использовать удочку и прикормку первого уровня, ваш навык
					не будет расти
				</Text>
				<ScrollContainer height={236} style={{ marginTop: 30 }}>
					<StyledLevelsContainer tabIndex={-1}>
						{Array.from({ length: skillData.maxLevel }).map((_, index) => (
							<StyledLevelItem key={index}>
								<StyledLevelHead $isInactive={index + 1 < skillData.level}>
									<StyledCircle
										$isInactive={index + 1 < skillData.level}
										$isNextLevel={index + 1 > skillData.level}
									>
										<Text>{index + 1}</Text>
									</StyledCircle>
									<Text>Уровень</Text>
									{index + 1 < skillData.level && <Text>Уровень получен</Text>}
									{index + 1 === skillData.level && (
										<Text>Текущий уровень</Text>
									)}
								</StyledLevelHead>
								<Divider $direction={'H'} style={{ opacity: 0.1 }} />
								<Text>
									<ul>
										<li>Деревянная удочка (В магазине)</li>
										<li>Прикормка Черви (В магазине)</li>
										<li>Доступно 1 и 2 зона для рыбалки</li>
									</ul>
								</Text>
							</StyledLevelItem>
						))}
					</StyledLevelsContainer>
				</ScrollContainer>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height50}
					style={{ width: 120, margin: '30px auto 0' }}
					onClick={() => dispatch(setModalSkillsVisible(false))}
				>
					<Text>Закрыть</Text>
				</Button>
			</StyledContainer>
		</StyledModalWrapper>
	);
};

export { ModalSkills };
